import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { IMeetingContentTreePageDto } from "../models/dto";
import { IMeetingDetail } from "../models/meeting";
import { RootStore } from "./rootStore";
import { history } from "../..";
import { toast } from "react-toastify";
import { BroadcastLauncherTypes } from "../models/broadcast";


export default class MeetingStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }
  isAskingDocumentalView : boolean = true;
  toListOrNot : boolean = false;
  loadingNodes: boolean = false;
  currentTree: IMeetingContentTreePageDto | null = null;
  meetingDetail: IMeetingDetail | null = null;
  sourceId: number | null = null;
  broadcastLauncherType : BroadcastLauncherTypes | undefined = undefined;

  setSourceId = (id: number | null) => {
    this.sourceId = id;
  };
  setMeetingCardsToListOrNot = ( toListOrNot : boolean) => {
    this.toListOrNot = toListOrNot;
  };
  updateDocumentalView = (value : boolean) => {
      this.isAskingDocumentalView = value;
  }
  
  broadcastOpeningEvaluation = () => {
    if(!this.isAskingDocumentalView && !this.rootStore.broadcastStore.session){
      this.rootStore.broadcastStore.updateLauncherMode(this.broadcastLauncherType)
      if(this.broadcastLauncherType !== null && this.broadcastLauncherType !== undefined)
        this.rootStore.broadcastStore.toggleIsBroadcastControllerOpen(true)
      this.isAskingDocumentalView = false;
    }
  };

  loadNodes = async (meetingId: number, languageId?: number) => {
    try {
      this.loadingNodes = true;
      const dto = await agent.Meeting.nodes(meetingId, languageId);
      runInAction(() => {
        this.currentTree = dto;
        if (
          languageId &&
          languageId !== this.rootStore.commonStore.selectedLanguageId
        )
          this.rootStore.commonStore.setSelectedLanguageId(dto.languageId);
        this.loadingNodes = false;
        // if(!this.isAskingDocumentalView && !this.rootStore.broadcastStore.session){
        //   this.rootStore.broadcastStore.updateLauncherMode(dto.broadcastLauncherType)
        //   if(dto.broadcastLauncherType !== null && dto.broadcastLauncherType !== undefined)
        //     this.rootStore.broadcastStore.toggleIsBroadcastControllerOpen(true)
        //   this.isAskingDocumentalView = false;
        // }
      });
      return dto;
    } catch (error) {
      console.log(error);
      this.loadingNodes = false;
      throw error;
    }
  };

  loadContent = async (nodeId: number, languageId?: number) => {
    const { commonStore } = this.rootStore;
    try {
      const dto = await agent.Meeting.content(nodeId, languageId);
      runInAction(() => {
        commonStore.setMeetingBrowsePageContent(dto);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  //  loadProtectedImageOrVideo = async (url: string) => {
  //   try {
     
  //     const result = await agent.Content.imageOrVideo(url);
  //     return result;
  //   } catch (error) {
  //     console.log( "ERRORE:" + error);
  //   }
  // };

  // loadProtectedImageOrVideo = async (url: string, cancel?: boolean | true) => {
  //   try {
    
  //     //  toast.info("loadProtectedImageOrVideo");
  //     this.rootStore.commonStore.abortRequest( this.rootStore.commonStore.CancelTokenSource);
      
  //     const result = await agent.Content.imageOrVideo(url);
  //     this.rootStore.commonStore.CancelTokenSource= result.sourcecancellation;

  //     return result.result;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  loadProtectedImageOrVideo = async (url: string) => {
    try {
    
      //  toast.info("loadProtectedImageOrVideo");
      if(!this.rootStore.commonStore.IsGallery){
        // toast.info("cancel");
        // caso sincronizzazione 
      this.rootStore.commonStore.abortRequest( this.rootStore.commonStore.CancelTokenSource);
      }else{
        // Galleria
        if(this.rootStore.commonStore.changePageGallery){
             //ogni volta che cambio la pagina della galleria cancello i vecchi caricamenti 
          // toast.error("Cambiato pagina");
          this.rootStore.commonStore.abortGalleryTokenRequest();
        }
      }
      const result = await agent.Content.imageOrVideo(url);
     
     if(this.rootStore.commonStore.IsGallery){
       this.rootStore.commonStore.setGalleryCancelToken(result.sourcecancellation)
     }else{
       // caso sincronizzazione
      this.rootStore.commonStore.CancelTokenSource= result.sourcecancellation;
     }
      return result.result;
    } catch (error) {
      console.log(error);
    }
  };
  loadProtectedThumbImageOrVideo = async (url: string) => {
    try {
    
      //  toast.info("loadProtectedImageOrVideo");
     
      const result = await agent.Content.imageOrVideo(url);
     
     
      return result.result;
    } catch (error) {
      console.log(error);
    }
  };
  resetNodeTree = () => {
    this.currentTree = null;
  };

  loadMeetingDetail = async (id: number) => {
    try {
      const dto = await agent.Meeting.details(id);
      runInAction(() => {
        this.rootStore.commonStore.allLanguages = dto.languages;
        if (dto.meeting) this.meetingDetail = dto.meeting;
        console.log(this.meetingDetail);
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  loadNodeDetails = async (meetingId: number, nodeId: number) => {
    try {
      const dto = await agent.Meeting.nodeDetails(meetingId, nodeId);
      console.log("loadNodeDetails FUNZIONA");
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  resetDetails = () => {
    this.meetingDetail = null;
    // this.invitedUsers = new Map<number, IInvitedUser>();
    // this.invitedGroups = new Map<number, IInvitedGroup>();
    // this.invitedTags = new Map<number, IInvitedTag>();
    // this.meetingRooms = new Map<number, IMeetingRoom>();
  };

  reloadMeetings = async () => {
    const {playerStore, userStore, tenantStore} = this.rootStore;
    try {
      if (tenantStore.currentTenant) {
        const dto = await agent.Meeting.refreshMeeting(tenantStore.currentTenant.id);
        runInAction(() => {
          this.broadcastLauncherType = dto.broadcastLauncherType;
          playerStore.setUserMeetings(dto.meetings);
          userStore.user = dto.user;
          tenantStore.canViewODG= dto.canViewODG;
        });
      } else {
        history.push("/home");
      }
    } catch (error) {
      throw error;
    }
  };
}
